// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WbvoF","name":"styles_name__3pp9-","phone":"styles_phone__2555F"};